<div class="main-component">
    <!-- <aoe-newsletter></aoe-newsletter> -->
    <div class="d-flex" style="padding: 30px 0 10px 0;">
        <div class="col-md-4 col-0 col-sm-0 d-flex flex-column justify-content-center align-items-center">
            <!-- <a [routerLink]="['contactez-nous']">Contactez nous</a> -->
        </div>
        <div class="col-md-4 col-6 d-flex justify-content-center align-items-center p-2">
            &copy; Alps Outdoor Events, {{yearCopyright}}, Tous droits réservés
        </div>

        <div class="col-md-4 col-6 d-flex flex-column justify-content-center align-items-center">
            <img src="/assets/img/Logo_URTIME_Couleur2-1024x307.png" alt="uRTime" id="logo-urtime" draggable="false">
        </div>
    </div>

</div>